import React, { FC, memo } from 'react';
import { Skeleton } from '@mui/material';
import { HeaderWrapper } from './header.styles';
import { PatientDetails, PatientInfo, PatientInfoWrapper, PatientName } from './contact-info/contact-info.styles';

export const PatientProfileHeaderSkeleton: FC = memo(() => {
  return <HeaderWrapper>
    <PatientInfoWrapper>
      <PatientInfo>
        <PatientName>
          <Skeleton variant="rounded" width={40} height={20} sx={{ marginRight: '10px' }} />
          <Skeleton variant="rounded" width={100} height={20} sx={{ marginRight: '10px' }} />
          <Skeleton variant="rounded" width={20} height={20} />
        </PatientName>
        <PatientDetails>
          <Skeleton variant="rounded" width={20} height={14} />
          <Skeleton variant="circular" width={4} height={4} sx={{ margin: '0 6px' }} />
          <Skeleton variant="rounded" width={70} height={14} />
          <Skeleton variant="circular" width={4} height={4} sx={{ margin: '0 6px' }} />
          <Skeleton variant="rounded" width={80} height={14} />
        </PatientDetails>
      </PatientInfo>
      <Skeleton variant="circular" width={52} height={52} sx={{ marginLeft: 'auto' }} />
    </PatientInfoWrapper>
  </HeaderWrapper>
});